import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { apiClient, configureAuth } from '@crestrewards/api-client';

import App from './App';
import './index.css';

// Point the shared client at THIS app's auth routes, before anything renders.
// Stated explicitly in both apps rather than leaning on the default, so a
// missing call here is a visible omission and not a silent fallback to the
// other app's endpoints. This is the tenant app.
configureAuth({ basePath: '/client/auth' });

/**
 * DEVELOPMENT ONLY — pretend this page was served from a tenant's subdomain.
 *
 * In production the tenant comes from the host: a client opens
 * acme.crestrewards.com and resolveTenant reads it off the request. Locally the
 * app is on localhost:5174, which resolves to no tenant at all, so every auth
 * call would fail with TENANT_NOT_RESOLVED.
 *
 * The backend already has the matching affordance — resolveTenant accepts an
 * x-tenant-subdomain header in development for exactly this reason.
 *
 * Guarded on import.meta.env.DEV as well as the variable, so it cannot ship: a
 * header that lets a caller choose their own tenant would be precisely the
 * tenant-isolation hole the rest of the design works to avoid.
 */
if (import.meta.env.DEV && import.meta.env.VITE_DEV_TENANT_SUBDOMAIN) {
  apiClient.interceptors.request.use((config) => {
    config.headers['x-tenant-subdomain'] = import.meta.env.VITE_DEV_TENANT_SUBDOMAIN;
    return config;
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
